import { RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const promotionCode: RouteObject[] = [
  {
    path: ROUTES.promotionCode.new,
    lazy: async () => {
      const { PromotionCodeFormPage } =
        await import('../../pages/promotion-code');

      return { Component: PromotionCodeFormPage };
    },
  },
  {
    path: ROUTES.promotionCode.edit,
    lazy: async () => {
      const { PromotionCodeFormPage } =
        await import('../../pages/promotion-code');

      return { Component: PromotionCodeFormPage };
    },
  },
  {
    path: ROUTES.promotionCode.copy,
    lazy: async () => {
      const { PromotionCodeFormPage } =
        await import('../../pages/promotion-code');

      return { Component: PromotionCodeFormPage };
    },
  },
];
